import React from "react";

// Maps a stored focal_point value to a CSS object-position string.
// Default leans slightly toward the top for face-safe cropping.
export const FOCAL_OPTIONS = [
  { value: "", label: "Auto (face-safe)" },
  { value: "50% 18%", label: "Top (face / head)" },
  { value: "50% 30%", label: "Upper" },
  { value: "50% 50%", label: "Center" },
  { value: "50% 70%", label: "Lower" },
  { value: "50% 90%", label: "Bottom" },
  { value: "20% 50%", label: "Left" },
  { value: "80% 50%", label: "Right" },
];

export function focalToCss(fp) {
  if (!fp) return "50% 18%"; // face-safe default
  return fp;
}

export default function PortfolioCard({ item, idx = 0, onClick, ratio, noCaption = false }) {
  // Vary aspect ratios subtly when not specified
  const ratioMap = ["aspect-[3/4]", "aspect-[4/5]", "aspect-[1/1]", "aspect-[4/3]"];
  const aspect = ratio || ratioMap[idx % ratioMap.length];
  return (
    <button
      type="button"
      onClick={onClick}
      className="group block w-full text-left card-brut overflow-hidden bg-pinkpanel focus:outline-none focus-visible:ring-4 focus-visible:ring-coral/40"
      data-testid={`portfolio-card-${item.id}`}
      aria-label={`Open ${item.title || "portfolio image"}`}
    >
      <div className={`relative ${aspect} overflow-hidden`}>
        <img
          src={item.image}
          alt={item.alt || item.title || "Portfolio image"}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
          style={{ objectPosition: focalToCss(item.focal_point) }}
        />
      </div>
      {!noCaption && (
        <div className="p-3 bg-cream border-t-2 border-ink flex items-center justify-between gap-2">
          <span className="eyebrow text-[0.65rem]">{item.category}</span>
          <span className="text-sm truncate">{item.title}</span>
        </div>
      )}
    </button>
  );
}
